import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NbButtonModule, NbCardModule, NbIconModule, NbInputModule, NbLayoutModule, NbSelectModule, NbThemeModule } from '@nebular/theme';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BotoesWhiteLabelComponent } from './components/botoes-whitelabel/botoes-whitelabel.component';
import { BreadcrumbComponent } from '../components/breadcrumb/breadcrumb.component';
import { FooterActionsComponent } from './components/footer-actions/footer-actions.component';
import { HeaderComponent } from './components/header/header.component';
import { ImportarPlanilhaLoteComponent } from './components/importar-planilha-lote/importar-planilha-lote.component';
import { InfoLoteImportacaoComponent } from './components/info-lote/info-lote.component';
import { ImportacaoInfoComponent } from './components/info/info.component';
import { LembreteImportacaoComponent } from './components/lembrete/lembrete.component';
import { ModalAcaoComponent } from './components/modals/modal-acao/modal-acao.component';
import {
  ModalHelpComponent,
} from './components/modals/modal-help/modal-help.component';
import { PaymentInfoComponent } from './components/payment-info/payment-info.component';
import { StatusComponent } from './components/status/status.component';
import { TableImportacaoComponent } from './components/table/table.component';
import { MyDatePickerModule } from 'mydatepicker';
import { InfoLoteAtivacaoImportacaoComponent } from './components/info-lote-ativacao/info-lote-ativacao.component';
import { ModalErroComponent } from './components/modals/modal-erro/modal-erro.component';
import { DatePickerComponent } from './components/datepicker/datepicker.component';
import { CpfCnpjPipe, PhoneMaskPipe, ZipCodePipe } from '../pipes/common.pipe';
import { StatusLoteEnumPipe, TipoCargaEnumPipe } from '../pipes/enums.pipe';
import { StatusErroComponent } from './components/status-erro/status-erro.component';
import { ComponentstModule } from '../components/components.module';

@NgModule({
  imports: [
    RouterModule,
    NbThemeModule.forRoot({ name: "default" }),
    NbLayoutModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NbCardModule,
    NbInputModule,
    NbSelectModule,
    NbIconModule,
    NbButtonModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    HttpClientModule,
    CurrencyMaskModule,
    NgxSpinnerModule,
    SimpleNotificationsModule,
    MyDatePickerModule,
    ComponentstModule
  ],
  declarations: [
    HeaderComponent,
    TableImportacaoComponent,
    StatusComponent,
    StatusErroComponent,
    ImportarPlanilhaLoteComponent,
    BreadcrumbComponent,
    ImportacaoInfoComponent,
    FooterActionsComponent,
    PaymentInfoComponent,
    InfoLoteImportacaoComponent,
    InfoLoteAtivacaoImportacaoComponent,
    LembreteImportacaoComponent,
    StatusLoteEnumPipe,
    TipoCargaEnumPipe,
    CpfCnpjPipe,
    PhoneMaskPipe,
    ZipCodePipe,
    ModalHelpComponent,
    ModalAcaoComponent,
    BotoesWhiteLabelComponent,
    ModalErroComponent,
    DatePickerComponent,
    StatusErroComponent,
  ],
  exports: [
    HeaderComponent,
    TableImportacaoComponent,
    StatusComponent,
    StatusErroComponent,
    ImportarPlanilhaLoteComponent,
    BreadcrumbComponent,
    FooterActionsComponent,
    ImportacaoInfoComponent,
    PaymentInfoComponent,
    InfoLoteImportacaoComponent,
    LembreteImportacaoComponent,
    ModalHelpComponent,
    ModalAcaoComponent,
    DatePickerComponent,
    InfoLoteAtivacaoImportacaoComponent,
    BotoesWhiteLabelComponent,
    ZipCodePipe,
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    NbIconModule,
    NbSelectModule,
    NbLayoutModule,
  ],
  entryComponents: [ModalHelpComponent, ModalAcaoComponent, ModalErroComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImportacaoLoteComponentsModule {}
